import mapboxgl from 'mapbox-gl';

export default class Mapbox {
  constructor(geojsonData, key, longitude, latitude, zoomLevel, containerId = 'poi-map', forceZoomLevel = 0) {
    // TO MAKE THE MAP APPEAR YOU MUST
    // ADD YOUR ACCESS TOKEN FROM
    // https://account.mapbox.com

    // Note: needs to be replaced with correct key (VWP-85)
    mapboxgl.accessToken = key;
    // End note
    const mapContainer = document.querySelector(`#${containerId}`);
    let scrollEnabled = false;
    const geojson = geojsonData;
    // eslint-disable-next-line no-unused-vars
    const map = new mapboxgl.Map({
      container: containerId, // container id
      style: 'mapbox://styles/mapbox/streets-v11', // style URL
      center: [longitude, latitude], // starting position [lng, lat]
      zoom: zoomLevel // starting zoom
    });

    // disable map zoom when using scroll
    map.scrollZoom.disable();
    if (window.innerWidth <= 800) {
      map.doubleClickZoom.enable();
      map.dragPan.disable();
    } else {
      map.doubleClickZoom.disable();
      map.dragPan.enable();
    }

    mapContainer.addEventListener('click', (options) => {
      if (scrollEnabled) {
        map.scrollZoom.disable();
        scrollEnabled = false;
      } else {
        map.scrollZoom.enable(options);
        scrollEnabled = true;
      }
    });

    // Get bounds to center the map around all the markers
    const bounds = new mapboxgl.LngLatBounds();
    geojson.features.forEach((feature) => {
      bounds.extend(feature.geometry.coordinates);
    });

    if (forceZoomLevel <= 0) {
      map.fitBounds(bounds, {padding: 100});
    }

    // mapstyle switch
    const layerList = document.getElementById('map-style-switch');

    function switchLayer(layer) {
      const layerId = layer.target.id;
      map.setStyle(`mapbox://styles/mapbox/${layerId}`);
    }

    if (layerList) {
      const buttons = layerList.getElementsByTagName('button');
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].onclick = switchLayer;
      }
    }

    // Add markers to the map.
    geojson.features.forEach((marker) => {
      // Create a DOM element for each marker.
      const el = document.createElement('div');
      el.className = `${marker.properties.className} marker`;
      el.style.backgroundImage = `${marker.properties.iconImage}`;
      // Check if current marker is the home marker. If true then make it a bit bigger
      if (marker.properties.className === 'marker-woning') {
        el.style.width = '40px';
        el.style.height = '55px';
      } else {
        el.style.width = '30px';
        el.style.height = '40px';
      }
      el.style.backgroundSize = '100%';
      el.setAttribute('title', `${marker.properties.title}`);
      const popup = new mapboxgl.Popup({
        offset: 0,
        anchor: 'top',
        closeButton: false,
        closeOnClick: true,
        closeOnMove: false,
        className: 'map-popup-box'
      })
      .setHTML(
        `<span>${marker.properties.title}</span>`
      );
      // Add markers to the map.
      new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .setPopup(popup)
        .addTo(map);
    });
    // Add zoom and rotation controls to the map.
    const nav = new mapboxgl.NavigationControl({
      showCompass: false
    });
    map.addControl(nav, 'bottom-right');
  }
}
